import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e9a23e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "shop-name" }
const _hoisted_3 = { class: "addr" }

import {CompassOutlined, PhoneOutlined} from "@ant-design/icons-vue";
import {editor} from "@/app/editor";
import {ShopSectionV1} from "@/app/editor/modules/shop/v1/index";
import FrameContentPreview from "@/app/editor/views/FrameContentPreview.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShopPreview',
  props: {
    index: {}
  },
  setup(__props: any) {


const props = __props
const shops = editor.activity?.modules[props.index] as ShopSectionV1

return (_ctx: any,_cache: any) => {
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(`section_${_ctx.index}`)
    }, null, 2),
    (_unref(shops).config.shop.sid > 0)
      ? (_openBlock(), _createBlock(FrameContentPreview, {
          key: 0,
          title: "联系店家"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_flex, {
              gap: "middle",
              vertical: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_flex, {
                  class: "shop",
                  gap: "middle",
                  justify: "space-between"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _unref(shops).config.shop.icon,
                      alt: ""
                    }, null, 8, _hoisted_1),
                    _createVNode(_component_a_flex, {
                      vertical: "",
                      class: "info",
                      align: "flex-start",
                      justify: "space-around"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(shops).config.shop.shop_name), 1),
                        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(shops).config.shop.area) + _toDisplayString(_unref(shops).config.shop.addr), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_flex, { justify: "space-around" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, { shape: "round" }, {
                      icon: _withCtx(() => [
                        _createVNode(_unref(CompassOutlined))
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" 查看位置 ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      danger: "",
                      shape: "round"
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_unref(PhoneOutlined))
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" 联系电话 ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})